import React from 'react';
import { MaterialIcon } from '../MaterialIcon';
export var BreadcrumbItemContent = function (_a) {
    var icon = _a.icon, _b = _a.title, title = _b === void 0 ? '' : _b;
    return (React.createElement(React.Fragment, null,
        !!icon && (React.createElement(MaterialIcon, { type: icon, style: { marginRight: title ? 8 : 0 } })),
        React.createElement("span", null, title)));
};
//# sourceMappingURL=BreadcrumbItemContent.js.map